export default __webpack_public_path__ + "static/media/Slider_4500_Mobile.8af45278.png";